import {useContext, useState} from 'react'
import {Link} from 'react-router-dom'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import {ProfitabilityContext} from '../../context'
import { MIN_DATE_RANGE } from '../../utils'
import ProfitTrendModal from '../modals/ProfitTrendModal'

const CustomerGroupRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const [showProfitTrendModal, setShowProfitTrendModal] = useState(false)

  const {
    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useContext(ProfitabilityContext)

  return (
    <>
      <tr>
        <td>
          <span>{row.customerGroup}</span>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&customer_group=${row.customerGroupId}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.orderCount}
          </Link>
        </td>
        <td>
          <span>{row.totalCost}</span>
        </td>
        <td>
          <span>{row.revenue}</span>
        </td>
        <td>{row?.contributionSalePercentage}</td>
        <td>
          <span>{row.totalProfit}</span>
        </td>
        <td>
          <span
            onClick={() => setShowProfitTrendModal(true)}
            className='text-hover-primary cursor-pointer text-decoration-underline'
            style={{cursor: 'pointer'}}
          >
            {row.totalProfitPercentage}
          </span>
        </td>
        <td>
          <span>{row.contributedProfitPercentage}</span>
        </td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>

      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.customerGroupId}
          entityName={`Profitability Report - ${row.customerGroup}`}
          onEntityPerformanceChartIdChange={onEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={onEntityPerformanceChartDateRangeChange}
          entityPerformanceChartFilters={entityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isEntityPerformanceChartDataLoading}
          entityPerformanceChartData={entityPerformanceChartData}
          startDate={MIN_DATE_RANGE}
        />
      )}

      {showProfitTrendModal && (
        <ProfitTrendModal
          onClose={() => setShowProfitTrendModal(false)}
          entityId={row.customerGroupId}
          entityName={row.customerGroup}
          onProfitTrendIdChange={onProfitTrendIdChange}
          isProfitTrendDataLoading={isProfitTrendDataLoading}
          profitTrendChartData={profitTrendChartData}
          kpiData={profitTrendKpiData}
          weeklyBreakdownData={profitTrendWeeklyBreakdownData}
        />
      )}
    </>
  )
}

export default CustomerGroupRow
